var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
var GET_EXPERIMENT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getExperiment {\n    me {\n      id\n      carouselVariant: abResource(key: \"PUBLIC_R_CAROUSEL_VARIANT\")\n    }\n  }\n"], ["\n  query getExperiment {\n    me {\n      id\n      carouselVariant: abResource(key: \"PUBLIC_R_CAROUSEL_VARIANT\")\n    }\n  }\n"])));
export default GET_EXPERIMENT;
var templateObject_1;
